import { render, staticRenderFns } from "./CardMap.vue?vue&type=template&id=0bc22476&scoped=true"
import script from "./CardMap.vue?vue&type=script&lang=js"
export * from "./CardMap.vue?vue&type=script&lang=js"
import style0 from "./CardMap.vue?vue&type=style&index=0&id=0bc22476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc22476",
  null
  
)

export default component.exports